/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myDisplays: []
};

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_DISPLAYS_DONE:
      return { ...state, myDisplays: action.data.items };
    case AT.ITEM_DELETE_DONE:
      if (action.itemType === 'Display') {
        return {
          ...state,
          myDisplays: R.reject((s: any) => s._id === action.itemId, state.myDisplays)
        };
      }

      return state;
    default:
      return state;
  }
}
